import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {checkTrackingBesideBarcode, packageByBatch} from '../../../services/api/apiNextBox'
import isTrackingNumber from "../helpers/isTrackingNumber"
import {pushNewItemHistory} from "../../../services/api/apiItemHistory"
import ReGenLabel from "./ReGenLabel"
import ModalError from "./notication/ModalError"

class NextBoxInput extends Component {
    constructor(props) {
        super(props)
        const {box} = props
        this.state = {
            barcode: '',
            submitted: false,
            arrBarcodes: [],
            arrTracking: '',
            messageErr: '',
            totalSuccess: 0,
            dataResults: [],
            dataError: [],
            loading: false,
            isOpen: false,
            error: '',
            isOpenError: false,
            box
        }

        this.textInput = React.createRef();
    }


    componentDidMount() {
        if(this.textInput.current){
            this.textInput.current.focus()
        }
    }

    _handleOnChange = e => {
        const {value} = e.target
        const {submitted} = this.state

        if (submitted) {
            this.setState({
                barcode: value,
                submitted: false,
                arrBarcodes: [],
                arrTracking: '',
                messageErr: '',
                totalSuccess: 0,
                dataResults: [],
                dataError: []
            },() => {
                const {barcode} = this.state
                const arrString = barcode.split("-")
                const newStr = arrString[arrString.length - 1]
                const checkBarcode = /^#([0-9]{6,})_([0-9]+)$/.test(newStr.trim())

                if(checkBarcode){
                    const arrBarcode = barcode.split("_") 
                    const itemNumber = arrBarcode[0]
                    return pushNewItemHistory(`${itemNumber}_1`, {
                        event_key: 'scan_barcode_to_package',
                        event_description: 'Barcode is scanned to package.',
                        event_meta: {
                            barcode: barcode,
                        }
                    })
                }
            })
        } else {
            this.setState({
                barcode: value,
            }, () => {
                const {barcode} = this.state
                const arrString = barcode.split("-")
                const newStr = arrString[arrString.length - 1]
                const checkBarcode = /^#([0-9]{6,})_([0-9]+)$/.test(newStr.trim())

                if(checkBarcode){
                    const arrBarcode = barcode.split("_") 
                    const itemNumber = arrBarcode[0]
                    return pushNewItemHistory(`${itemNumber}_1`, {
                        event_key: 'scan_barcode_to_package',
                        event_description: 'Barcode is scanned to package.',
                        event_meta: {
                            barcode: barcode,
                        }
                    })
                }
            })
        }
    }

    _addToBox = async(id, payload) => {
        const {onRefresh, onUpdateLocalStore} = this.props
        try {
            const {data, success: successParent, message} = await checkTrackingBesideBarcode(id, payload)

            if (!successParent) {
                return this.setState({
                    submitted: true,
                    loading: false
                }, () => {
                    this.textInput.current.focus()
                    this.setState({
                        barcode: '',
                        isOpenError: true,
                        error: message
                    })
                })
            }

            const { success = [], result = [], error = [] } = { ...data }

            if (error.length > 0) {
                const barcodeError = error.map(item => item.barcode)
                onUpdateLocalStore(id, barcodeError)
            }

            this.setState({
                submitted: true,
                dataResults: success,
                dataError: error,
                totalSuccess: result.length || success.length,
                loading: false,
                isOpen: true
            }, () => {
                this.textInput.current.focus()
                if ((result.length > 0 && result[0] !== null) || (success.length > 0 && success[0] !== null)) {
                    this.setState({
                        barcodeError: error
                    })
                    onRefresh()
                }
            })

        } catch (err) {
            this.setState({
                submitted: true,
                loading: false
            },() => {
                this.textInput.current.focus()
            })
            window.alert(err.message)
        }
    }

    _packageByBatch = async(id, payload) => {
        const {onRefresh, onUpdateLocalStore} = this.props
        try {
            const {data, success: successParent, message} = await packageByBatch(id, payload)

            if (!successParent) {
                return this.setState({
                    submitted: true,
                    loading: false
                }, () => {
                    this.textInput.current.focus()
                    this.setState({
                        barcode: '',
                        isOpenError: true,
                        error: message
                    })
                })
            }

            const { success = [], error = [] } = { ...data }

            if (error.length > 0) {
                const barcodeError = error.map(item => item.barcode)
                onUpdateLocalStore(id, barcodeError)
            }

            this.setState({
                submitted: true,
                dataResults: success,
                dataError: error,
                totalSuccess: success.length,
                loading: false,
                isOpen: true
            }, () => {
                this.textInput.current.focus()
                if (success.length > 0 && success[0] !== null) {
                    this.setState({
                        barcodeError: error
                    })
                    onRefresh()
                }
            })

        } catch (err) {
            this.setState({
                submitted: true,
                loading: false
            }, () => {
                this.textInput.current.focus()
            })
            window.alert(err.message)
        }
    }

    _handleSubmit = async e => {
        e.preventDefault()

        const {box} = this.props
        // const {id: boxNumber} = Object.assign({}, box)
        const {arrBarcodes, barcode} = this.state
        const arrString = barcode.split("-")
        const newStr = arrString[arrString.length - 1]
        const check = /^#([0-9]{6,})_([0-9]+)?$/.test(newStr.trim())
        const check1 = /^#([0-9]{6,})?$/.test(newStr.trim())

        if (check || check1) {
            if(check) arrBarcodes.push(newStr.trim())
            this.setState({
                arrBarcodes,
                barcode: '',
                messageErr: ''
            })
            if(check1){
                this.setState({
                    barcode: '',
                    messageErr: '',
                    loading: true
                })
                const payload = {
                    barCodes: [newStr]
                }
                this._packageByBatch(box._id, payload)
                return
            }
        } else {
            if (arrBarcodes.length > 0) {
                const trackingCheck = isTrackingNumber(newStr)

                if (!trackingCheck) {
                    return this.setState({
                        barcode: '',
                        arrBarcodes: [],
                        isOpenError: true,
                        error: 'Bạn đã nhập sai định dạng Tracking Number vui lòng kiểm tra lại.'
                    })
                }

                this.setState({
                    arrTracking: (newStr.replace('%', '')).trim(),
                    barcode: '',
                    messageErr: '',
                    loading: true
                })
                const payload = {
                    barCodes: arrBarcodes,
                    trackingNumber: (newStr.replace('%', '')).trim(),
                    box
                }
                this._addToBox(box._id,payload)
            } else {
                this.setState({
                    barcode: '',
                    isOpenError: true,
                    error: 'Bạn đã nhập sai Barcode vui lòng kiểm tra lại. Định dạng đúng ex: #123456_1'
                })
            }
        }
    }

    _onClosePopup = () => {
        this.textInput.current.focus()
        this.setState({
            isOpen: false,
            isOpenError: false
        })
    }

    render() {
        const {box} = this.props
        const {
            arrBarcodes,
            arrTracking,
            dataResults,
            dataError,
            totalSuccess,
            loading,
            isOpen,
            barcode,
            error,
            isOpenError
        } = this.state
        const {status} = box

        if (status !== 'opening') return null

        return (
            <div className="NextBoxInput mt-3">
                <form className="mb-3" onSubmit={this._handleSubmit}>
                    <div className="form-group">
                        <div className="d-flex flex-column">
                            <label className='mr-5'>
                                <b>*</b> Bạn quét(nhập) vào mã <b>Barcode</b> trước và sau đó là <b>Tracking number</b>.
                            </label>
                            <label className='mr-5'>
                                <b>*</b> Đơn ship nhanh(<b>SB_FAST</b>) quét(nhập) vào mã <b>Barcode</b> ví dụ: <b>#123456</b>.
                            </label>
                            <label>
                                <b>*</b> Đơn <b>LLC</b> quét(nhập) vào mã <b>Barcode</b> sau đó là <b>Tracking number</b> ví dụ: <b>#123456_1</b> - <b>123456</b>.
                            </label>
                        </div>
                        <input
                            ref={this.textInput}
                            type="text"
                            className="BoxInput form-control"
                            value={barcode}
                            placeholder="Quét QR"
                            autoFocus
                            onChange={this._handleOnChange}
                            disabled={loading}
                        />

                        {loading && <i className="fa fa-spinner fa-spin"/>}
                    </div>
                </form>

                <div className="d-flex align-item-center justify-content-between">
                    <div>
                        {arrBarcodes.length > 0 && <h6>Thông tin đã nhập/quét vào:</h6>}

                        <div className='d-flex align-items-center mb-2'>
                            {
                                arrBarcodes.length > 0 && (
                                    <div className="barCodes">
                                        <label className="mr-3 mb-0"><strong>Barcodes:</strong></label>
                                        {
                                            arrBarcodes.map((item, index) => {
                                                return (
                                                    <span className="mr-3" key={index}>{item}</span>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            }

                            <ReGenLabel arrBarcodes={arrBarcodes}/>
                        </div>

                        {
                            arrTracking !== '' && (
                                <div className="barCodes">
                                    <label className="mr-3"><strong>Traking number/Order number:</strong></label>
                                    {arrTracking}
                                </div>
                            )
                        }
                    </div>

                    {
                        totalSuccess > 0 && (
                            <div className="totalSuccess">
                                <strong>{totalSuccess}</strong> sản phẩm được đóng thùng
                            </div>
                        )
                    }
                </div>

                {
                    (dataResults.length > 0) && (
                        <div className="">
                            {dataResults.map(item => {
                                return (
                                    <div key={item._id} className="text-success">{item.message}</div>
                                )
                            })}
                        </div>
                    )
                }

                <ModalError isOpen={isOpenError} onClose={this._onClosePopup} error={error} dataError={dataError} isOpenDataErr={isOpen} onClosePopup={this._onClosePopup}/>

            </div>
        )
    }
}

NextBoxInput.propTypes = {
    box: PropTypes.object.isRequired,
    onRefresh: PropTypes.func.isRequired,
}

export default NextBoxInput
